const CoursePlayerHeader = ({ course, onClose, onToggleSidebar }) => {
  return (
    <div className="course-player-header">
      <div className="d-flex align-items-center">
        {/* Mobile sidebar toggle button */}
        {onToggleSidebar && (
          <button
            className="btn btn-link text-white d-md-none me-2"
            onClick={onToggleSidebar}
          >
            <i className="fas fa-bars"></i>
          </button>
        )}
        <button className="btn btn-link text-white me-3" onClick={onClose}>
          <i className="fas fa-arrow-left"></i>
        </button>
        <h5 className="text-white mb-0">{course.title}</h5>
      </div>
      <div className="d-flex align-items-center">
        <span className="text-white me-3">
          Your Progress: {course.progress.completed} of {course.progress.total} ({course.progress.percentage}%)
        </span>
        <button className="btn btn-link text-white" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  )
}

export default CoursePlayerHeader